import {DomSanitizer} from "@angular/platform-browser";
import {UserNotification, NotificationDecorator, TableauLicenseNotification} from "../interefaces/notification.interface";

export class TableauLicenseNotificationDecorator implements NotificationDecorator {
  constructor(private _sanitizer: DomSanitizer) {
  }

  decorate(notification: UserNotification): UserNotification {
    if (notification.body) {
      const tableLicenseNotification = JSON.parse(notification.body) as TableauLicenseNotification;
      const subject = `Tableau License Alert`;
      notification.htmlSubject = this._sanitizer.bypassSecurityTrustHtml(subject);
      const body = `Tableau contract "${tableLicenseNotification.contractName}" threshold ${tableLicenseNotification.threshold}% is exceeded`
      notification.htmlBody = this._sanitizer.bypassSecurityTrustHtml(body);
    } else {
      notification.htmlSubject = this._sanitizer.bypassSecurityTrustHtml('');
      notification.htmlBody = this._sanitizer.bypassSecurityTrustHtml('');
    }
    return notification;
  }
}
